import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { aboutIcons } from "./aboutIcons";
import { industryExperienceContent } from "./aboutContent";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const AboutIndustries = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="about-industries-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-industries-heading"
        title={industryExperienceContent.title}
        subtitle={industryExperienceContent.intro}
        /* a lead-in sentence, not a heading — the document gives this section
           no sub-heading of its own */
        subtitleAs="p"
        subtitleClassName="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-gray-600"
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {industryExperienceContent.industries.map((industry) => {
          const Icon = aboutIcons[industry.icon];
          return (
            <motion.li
              key={industry.name}
              variants={itemVariants}
              className="brand-card"
            >
              <Link
                to={industry.to}
                className="flex h-full items-center gap-4 p-5 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
                <span className="text-sm md:text-base font-semibold text-gray-900">
                  {industry.name}
                </span>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default AboutIndustries;
